// Vendor scripts
import 'bootstrap';
import 'swiper';

// Vue application
import './vue/vue.js';

// Custom scripts
import './scripts/swiper-config';
import './scripts/wf-dropdown';
import './scripts/wf-inspiration';
import './scripts/wf-local-rep';
import './scripts/wf-sidepane';
import './scripts/wf-side-collapse';
import './scripts/pc-gtm-global-events';
